// extracted by mini-css-extract-plugin
export var desktopLinks = "glossary-module--desktopLinks--9da1c";
export var glossary = "glossary-module--glossary--c7b49";
export var glossaryLinkBar = "glossary-module--glossaryLinkBar--7d2ac";
export var letterSection = "glossary-module--letterSection--333dc";
export var mobileLinks = "glossary-module--mobileLinks--0aaa7";
export var mobileSelect = "glossary-module--mobileSelect--edae8";
export var mobileSelectWrapper = "glossary-module--mobileSelectWrapper--aa59f";
export var sectionHeading = "glossary-module--sectionHeading--e9246";